<template>
  <v-container fluid class="container-page">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="d-flex v-middle text-title-container justify-space-between"
      >
        <div class="text-title text-primary">Voice outbound</div>
        <div class="d-flex v-middle">
          <VueCtkDateTimePicker
            v-model="from"
            :max-date="to"
            :format="$datetimeFormatDefault"
            :no-value-to-custom-elem="true"
            :no-button-now="true"
            class="width150px m-l-10"
          >
            <v-text-field
              :hide-details="true"
              class="font-size-body"
              v-model="dateFrom"
              prepend-inner-icon="mdi-calendar small"
              label="From"
              readonly
              dense
            ></v-text-field>
          </VueCtkDateTimePicker>
          <VueCtkDateTimePicker
            v-model="to"
            :min-date="from"
            :format="$datetimeFormatDefault"
            :no-value-to-custom-elem="true"
            :no-button-now="true"
            class="width150px m-l-10"
          >
            <v-text-field
              :hide-details="true"
              class="font-size-body"
              v-model="dateTo"
              prepend-inner-icon="mdi-calendar small"
              label="To"
              readonly
              dense
            ></v-text-field>
          </VueCtkDateTimePicker>
          <v-icon class="m-l-5 m-t-5" @click="manualRefresh">
            fa-play-circle
          </v-icon>
          <v-chip-group class="m-l-10 height43px">
            <v-chip
              v-for="(time, index) in timeList"
              :key="index"
              :color="timeSelected === time.value ? 'primary' : 'default'"
              :text-color="timeSelected === time.value ? 'white' : 'black'"
              @click="clickChip(time.value)"
            >
              {{ time.name }}
            </v-chip>
          </v-chip-group>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col sm="6" lg="3">
        <v-card
          v-if="noCampaign"
          outlined
          class="white pt-1 pb-1"
          :elevation="5"
          @click="
            viewConver({
              from,
              to,
              direction,
              type
            })
          "
        >
          <widget-voice-session
            :clear="clear"
            :refresh="refresh"
            :from="from"
            :to="to"
            title="Outbound calls"
            :direction="direction"
          />
        </v-card>
        <v-card v-else outlined class="white pt-1 pb-1" :elevation="5">
          <widget-voice-call
            :clear="clear"
            :refresh="refresh"
            :from="from"
            :to="to"
            :direction="direction"
          />
        </v-card>
      </v-col>
      <v-col sm="6" lg="3">
        <v-card
          v-if="noCampaign"
          outlined
          class="white pt-1 pb-1"
          :elevation="5"
          @click="
            viewConver({
              from,
              to,
              direction,
              type,
              group: 'session-success'
            })
          "
        >
          <widget-voice-session-success
            :clear="clear"
            :refresh="refresh"
            :from="from"
            :to="to"
            :direction="direction"
          />
        </v-card>
        <v-card
          v-else
          outlined
          class="white pt-1 pb-1"
          :elevation="5"
          @click="
            viewConver({
              from,
              to,
              direction,
              type
            })
          "
        >
          <widget-voice-answered-call
            :clear="clear"
            :refresh="refresh"
            :from="from"
            :to="to"
            :direction="direction"
          />
        </v-card>
      </v-col>
      <v-col sm="6" lg="3">
        <v-card outlined class="white pt-1 pb-1" :elevation="5">
          <widget-voice-campaign
            :clear="clear"
            :refresh="refresh"
            :from="from"
            :to="to"
            :direction="direction"
          />
        </v-card>
      </v-col>
      <v-col sm="6" lg="3">
        <v-card
          outlined
          class="white pt-1 pb-1"
          :elevation="5"
          @click="
            viewConver({
              from,
              to,
              direction,
              type,
              group: 'transfer'
            })
          "
        >
          <widget-voice-transfer
            :clear="clear"
            :refresh="refresh"
            :from="from"
            :to="to"
            :direction="direction"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="7" class="position-relative">
        <stacked-voice-session-success
          :clear="clear"
          :refresh="refresh"
          :from="from"
          :to="to"
          :direction="direction"
        />
        <v-btn-toggle
          v-model="refresh.group"
          class="floating-group m-auto"
          mandatory
          dense
        >
          <v-btn small value="day" @click="trigger('day')"> Day </v-btn>
          <v-btn small value="month" @click="trigger('month')"> Month </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="5">
        <heatmap-voice
          :clear="clear"
          :refresh="refresh"
          :from="from"
          :to="to"
          :direction="direction"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Moment from 'moment'

import apiDashboard from '@/apis/dashboard'

import WidgetVoiceCall from './components/voice_outbound/widget_voice_call'
import WidgetVoiceAnsweredCall from './components/voice_outbound/widget_voice_answered_call'
import WidgetVoiceSession from './components/widget_voice_session'
import WidgetVoiceSessionSuccess from './components/widget_voice_session_success'
import WidgetVoiceCampaign from './components/widget_voice_campaign'
import WidgetVoiceTransfer from './components/widget_voice_transfer'

import StackedVoiceSessionSuccess from './components/stacked_voice_session_success'
import HeatmapVoice from './components/heatmap_voice'

export default {
  components: {
    WidgetVoiceCall,
    WidgetVoiceAnsweredCall,
    WidgetVoiceSession,
    WidgetVoiceSessionSuccess,
    WidgetVoiceCampaign,
    WidgetVoiceTransfer,
    StackedVoiceSessionSuccess,
    HeatmapVoice
  },
  data() {
    return {
      items: [],
      format: 'YYYY-MM-DD HH:mm',
      from: '',
      to: '',
      type: 'voice',
      direction: 'outbound',
      refresh: {
        count: 0,
        group: ''
      },
      clear: 0,
      timeSelected: '',
      timeList: [
        { name: 'Today', value: 'today' },
        { name: 'Yesterday', value: 'yesterday' },
        { name: 'Last 7 days', value: 'last_7_days' },
        { name: 'This month', value: 'this_month' },
        { name: 'Last month', value: 'last_month' },
        { name: 'This year', value: 'this_year' }
      ],
      open: {
        teamplate1: false,
        teamplate2: true
      },
      noCampaign: process.env.VUE_APP_NO_CAMPAIGN === 'true'
    }
  },
  computed: {
    dateFrom() {
      return this.$options.filters.convertDatetimePicker(this.from)
    },
    dateTo() {
      return this.$options.filters.convertDatetimePicker(this.to)
    }
  },
  async created() {
    this.noCampaign = this.$route.query.noCampaign
      ? this.$route.query.noCampaign === 'true'
      : process.env.VUE_APP_NO_CAMPAIGN === 'true'

    document.title = this.$t('page-title.dashboard', {
      productName: this.$options.filters.getVariable('product_name')
    })
    // await this.initial()
    await this.clickChip('today')
  },
  watch: {
    from: {
      handler() {
        this.clear += 1

        this.timeSelected = ''
      }
    },
    to: {
      handler() {
        this.clear += 1

        this.timeSelected = ''
      }
    }
  },
  methods: {
    async initial() {
      await this.getInitialDashboard()
    },
    async getInitialDashboard() {
      try {
        const getInitialDashboard = await apiDashboard.getInitialDashboard()

        this.items = await getInitialDashboard.items.sort(this.compare)
      } catch (error) {}
    },
    async clickChip(value) {
      await this.selectRange(value)
      this.timeSelected = value
    },
    selectRange(value) {
      switch (value) {
        case 'today':
          this.from = Moment()
            .startOf('day')
            .format(this.format)
          this.to = Moment()
            .add(1, 'days')
            .startOf('day')
            .format(this.format)
          this.refresh.group = 'day'

          break
        case 'yesterday':
          this.from = Moment()
            .add(-1, 'days')
            .startOf('day')
            .format(this.format)
          this.to = Moment()
            .startOf('day')
            .format(this.format)
          this.refresh.group = 'day'

          break
        case 'last_7_days':
          this.from = Moment()
            .add(-6, 'days')
            .startOf('day')
            .format(this.format)
          this.to = Moment()
            .add(1, 'days')
            .startOf('day')
            .format(this.format)
          this.refresh.group = 'day'

          break
        case 'this_month':
          this.from = Moment()
            .startOf('month')
            .format(this.format)
          this.to = Moment()
            .add(1, 'days')
            .startOf('day')
            .format(this.format)
          this.refresh.group = 'day'

          break
        case 'last_month':
          this.from = Moment()
            .add(-1, 'months')
            .startOf('month')
            .format(this.format)
          this.to = Moment()
            .startOf('month')
            .format(this.format)
          this.refresh.group = 'day'

          break
        case 'this_year':
          this.from = Moment()
            .startOf('year')
            .format(this.format)
          this.to = Moment()
            // .add(1, 'year')
            // .startOf('year')
            .add(1, 'days')
            .startOf('day')
            .format(this.format)
          this.refresh.group = 'month'

          break
      }

      this.refresh.count += 1
    },

    manualRefresh() {
      this.refresh.count += 1
      this.calDay()
    },

    viewConver(query) {
      let routeData = this.$router.resolve({
        path: '/conversations',
        query
      })
      window.open(routeData.href, '_blank')
    },

    calDay() {
      const start = Moment(this.from, this.format)
      const end = Moment(this.to, this.format)

      const diff = Moment.duration(end.diff(start)).asDays()

      if (diff > 62) this.refresh.group = 'month'
      else this.refresh.group = 'day'
    },

    trigger(type) {
      this.refresh.group = type
    }
  }
}
</script>

<style lang="scss" scoped>
// .box-filter {
//   position: fixed;
//   top: 50;
//   width: 100%;
//   z-index: 1;
//   transition: 0.2s;

//   &.has-background {
//     background: #ffffff;
//     box-shadow: 0px 0px 9px 3px rgba(41, 41, 41, 0.25);
//   }
// }

.box-select {
  margin-top: -14px;
}

.refresh-time {
  font-size: 1em;
}

.refresh-icon {
  &:hover {
    cursor: pointer;
  }
}

.height43px {
  height: 43px;

  ::v-deep .v-size--default {
    font-size: 12px;
  }
}

.width150px {
  width: 150px;
  min-width: 150px;

  .v-input {
    margin-bottom: -8px;
  }
}
</style>
